import { Routes } from '@angular/router';
import { WelcomeComponent } from './welcome/welcome.component';
import { UserSettingsComponent } from './user-settings/user-settings.component';
import { ProjectSettingsComponent } from './project-settings/project-settings.component';
import { AuthLandingComponent } from './auth-landing/auth-landing.component';
import { JoinProjectComponent } from './join-project/join-project.component';
import { MyprojectsComponent } from './myprojects/myprojects.component';
import { WorkspaceComponent } from './workspace/workspace.component';
import { PublicationComponent } from './publication/publication.component';
import { StatsComponent } from './stats/stats.component';

export const routes: Routes = [
    { path: 'profile', component: UserSettingsComponent },
    { path: 'settings/:projectid', component: ProjectSettingsComponent },
    { path: '', component: WelcomeComponent },
    { path: 'login', component: AuthLandingComponent },
    { path: 'join', component: JoinProjectComponent },
    { path: 'myprojects', component: MyprojectsComponent },
    { path: 'workspace/:projectid', component: WorkspaceComponent },
    { path: 'workspace', component: WorkspaceComponent },
    { path: 'publication/pdf/:projectid', component: PublicationComponent },
    { path: 'stats/:projectid/:bid', component: StatsComponent },
    { path: 'stats/:projectid', component: StatsComponent },
];
